import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSalesforceComponent } from './simple-icons-salesforce.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSalesforceComponent ],
    exports:      [ SimpleIconsSalesforceComponent ],
    bootstrap:    []
})
export class SimpleIconsSalesforceModule {}
